import PTPayrollPage from "./PTPayrollPage";

export default function PTFinancePage() {
  return <PTPayrollPage />;
}
